export default "__VITE_ASSET__30a1eb78__"